/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react';
import { Badge } from '@chakra-ui/react';
import { gql, useLazyQuery } from '@apollo/client';

const Q_COUNT = gql`
	query getNpCount {
		getNpCount
	}
`;

function NoteOfPresentationBadge() {
	const [loadNpCount, { data }] = useLazyQuery(Q_COUNT);

	useEffect(loadNpCount, []);

	const count = useMemo(() => parseInt(data?.getNpCount?.unreadCount), [data]);

	return (
		<>
			{count > 0 && (
				<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
					{count}
				</Badge>
			)}
		</>
	);
}

export default NoteOfPresentationBadge;
